import { TblCatUsuario } from "./Tables";

export interface Usuario {
  IdEmpleado: number;
  IdUsuario: string;
  Nombre: string;
  Correo: string;
  IdEstatus: number;
  FechaAlta: string;
  FechaMod: string;
  Roles: Rol[];
  IdRegion?: number;
  Browser?: string;
  IdTipoAplicacion?: number;
  IpSesion?: string;
  Token?: string;
  IdNegocio: number
  IdEstacion: number
}

export interface Rol {
  IdRol: number;
  Descripcion?: string;
  IdEstatus?: number;
  FechaAlta?: string;
}

export interface Negocios {
  Negocio_Descripcion: string
  Negocio_Id: number
}

export interface Region {
  idRegion: number;
  nombre: string;
  idEstatus: number;
  fechaAlta: string;
}

export type CatRegionesDTO = {
  Negocio_Id: number
}

export interface Estacion {
  idEstacion: number;
  idRegion: number;
  nombre: string;
  descripcion: string;
  estado: string;
  latitud: string;
  longitud: string;
  concesion: string;
  idIcono: number;
  dLatitud: number;
  dLongitud: number;
}

export interface RelacionUsuario {
  IdEmpleado: number;
  IdNegocio: number;
  IdRegion: number;
  IdEstacion: number;
  IdRol: number;
}

export interface RelacionUsuarioDTO {
  rel: RelacionUsuario
}

export interface UsuarioConfig extends RelacionUsuario {
  Nombre: string
}

export interface RegionesEstacionesDTO extends Pick<RelacionUsuario, 'IdNegocio' | 'IdRegion'> { }

export interface BajaUsuarioDTO {
  idEmpleado: number;
  idEmpleadoSesion: number;
}

export interface ValidUser {
  Token: string;
  Browser: string;
  IdTipoAplicacion: number;
  IdEmpleado: number;
  IpSesion: string;
  Roles: Rol[];
}

export interface UsuarioDTO {
  usuario: ValidUser
}

export interface UpdateRevisionDTO {
  id: number;
  objetivo: string;
  alcance: string;
}

export interface RevisionesFiltroDTO {  
  Negocio_Id: number;
  IdRegion: number;
  IdEstacion: number;
  IdEtapa: number;
  IdTipoRevision: number;
  FechaInicioPlan: string;
  FechaFinPlan: string;
  FechaInicioReal: string;
  FechaFinReal: string;
}

export interface LoginDTO {
  Code?: string;
  Token: string;
  IdTipoAplicacion: number;
  IdEmpleado: number;
}

export interface EstatusRubro {
  IdEstatusRubro: number;
  IdEtapa: number;
  Descripcion: string;
  Color: string;
}

export interface TranRespuesta {
  IdRespuesta: number;
  IdPregunta: number;
  IdRevision: number;
  IdEmpleadoContesta: number;
  Calificacion: number;
  Texto: string;
  FechaMod: string;
  FechaSync: string;
  IdRelacion: number;
  Comentario: string;
}

export interface RespuestaTranRespuesta extends TranRespuesta {
  Label: string;
  IdTipoInput: number;
  Type: string;
  IdPreguntaDinamica: string;
}

export interface TranEvidencia {
  IdEvidencia: string;
  IdPregunta: number;
  IdRevision: number;
  IdEmpleadoCarga: number;
  NombreEvidencia: string;
  ContenidoEvidencia: ArrayBuffer;
  IdEstatus: number;
  FechaMod: string;
  FechaSync: string;
  IdPreguntaDinamica: string;
  ContenidoEvidenciaThumbnail: ArrayBuffer;
  Longitude: number;
  Latitude: number;
}

export interface TranEvidenciaBase64 extends TranEvidencia {
  ContenidoEvidenciaBase64: string;
  ContenidoEvidenciaMinBase64: string;
}

export interface TranPregunta {
  IdPregunta: number;
  IdRevision: number;
  Calificacion: number;
  FechaMod: string;
  FechaSync: string;
  IdPreguntaDinamica: string;
}

export interface PreguntaTranPregunta extends TranPregunta {
  Descripcion: string;
  Orden: number;
  FlagEvidencia: boolean;
  Respuestas?: RespuestaTranRespuesta[];
  Evidencias?: TranEvidenciaBase64[];
  FlagDynamic: boolean;
}

export interface TranRubro {
  IdRubro: number;
  IdRevision: number;
  Calificacion: number;
  IdEstatus: number;
  IdNivelValidacion: number;
  FechaMod: string;
  FechaSync: string;
  ObservacionesInformeFinal: string;
}

export interface RubroTranRubro extends TranRubro {
  Nombre: string;
  Descripcion: string;
  Ponderacion: number;
  Orden: number;
  IdRolValidacion: number;
  RolValidacion: string;
  Preguntas?: PreguntaTranPregunta[];
  IdEtapaRevision: number;
}

export interface TranBloque {
  IdBloque: number;
  IdRevision: number;
  Calificacion: number;
  FechaMod: string;
  FechaSync: string;
}

export interface BloqueTranBloque extends TranBloque {
  Nombre: string;
  Ponderacion: number;
  Orden: number;
  Rubros?: RubroTranRubro[];
}

export interface TranChecklist {
  IdChecklist: number;
  IdRevision: number;
  Calificacion: number;
  FechaMod: string;
  FechaSync: string;
}

export interface ChecklistTranChecklist extends TranChecklist {
  Bloques?: BloqueTranBloque[];
}

export interface GlobalChecklistValidacion {
  userSesion: TblCatUsuario | null;
  idRevision: number;
  CatEstatusRubro: EstatusRubro[] | null;
}

export interface UsuarioNombreIdEmpleadoDTO {
  idEmpleado: number;
  nombreIdEmpleado: string;
}